import React from 'react'
import { Text, View } from 'react-native'
import { darkLightColor, disabledGray } from '../../../theme/colors'

interface Props {
  mortalityName: string
  totalEntered: number
  date: string
}

export const DescriptionMortality = ({ totalEntered, date, mortalityName }: Props) => {
  return (
    <View>
      <Text style={{ color: disabledGray }}>Registro pendiente: {mortalityName}</Text>
      <Text style={{ color: disabledGray }}>Total mortalidad ingresada: {totalEntered}</Text>
      <Text style={{ fontWeight: 'bold', color: darkLightColor }}>Fecha Mortalidad: {date}</Text>
    </View>
  )
}
